import React from 'react'
import styled from 'styled-components'
import Box from '@ui/Box'
import NextHead from 'next/head'
import HeadCTA from '@components/Landing/HeadCTA'
import TryButton from '@components/Landing/TryButton'
import Text from 'parchment/src/blot/text'
import Flex from '@ui/Flex'
import HelpCentreButton from '@components/Landing/HelpCentreButton'
import routes from '@routes'

const Wrap = styled(Box)`
  margin-top: 200px;

  @media (max-width: 768px) {
    margin-top: 100px;
  }
`

const Title = styled.h2`
  font-size: 70px;
  font-weight: 500;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 50px;
  }
`

const Content = styled.div``

const Video = styled.iframe`
  max-width: 1200px;
  width: 100%;
  height: 615px;
  margin-top: 32px;
  border-radius: 30px;
`

interface Props {
  helpUrl: string
  platform: string
}

const HowToInstall = ({ helpUrl, platform }: Props) => {
  return (
    <>
      <Wrap id="how-it-works">
        <Title>How to install?</Title>
        <Content>
          <Box fontSize={22} textAlign="center">
            We have a detailed guide on how to install the pricing table to your{' '}
            {platform} website. <br />
            It's easy and takes only a few minutes.
          </Box>
          <Flex justifyContent="center">
            <HelpCentreButton mt={32} href={helpUrl} />
          </Flex>
        </Content>
      </Wrap>
    </>
  )
}

export default HowToInstall
